module.exports = __webpack_public_path__ + "img/greenLogo.d5e4360c.svg";